import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import siteConfig from '../../../siteConfig'
import Logo from 'images/logo/logo.png'
import FollowBar from './FollowBar'
import Mobile from './Mobile'
import Secondary from './Secondary'

const styles = (theme) => ({
  logoWrapper: {
    position: 'relative',
    width: 230,
    height: 50,
    left: 30,
    // overflow: 'hidden',
  },
  logo: {
    position: 'absolute',
    top: -70,
    // top: -90,
    // maxWidth: 220,
    width: '100%',
    // height: 180,
    // position: 'absolute',
    clip: 'rect(0px, auto, 120px, 0px)',
    [theme.breakpoints.down('xs')]: {
      transform: 'scale(0.7)',
    },
  },
  navigation: {
    position: 'absolute',
    width: '100%',
    margin: 'auto',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      left: 260,
    },
    [theme.breakpoints.down('xs')]: {
      left: 175,
      transform: 'scale(0.9)',
    },
  },
  navigationDesktop: {
    display: 'inline-block',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  navigationMobile: {
    minWidth: 110,
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'inline-block',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  followBar: {
    padding: 1,
    position: 'absolute',
    right: 0,
    // left: 280,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  navigationLink: {
    margin: '0 8px',
    textTransform: 'uppercase',
    display: 'inline-block',
    color: theme.palette.link.nav,
    fontSize: '0.9em',
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8em',
    },
  },
})

const Navigation = ({ classes, theme, width }) => {
  if (!width) {
    throw new Error('Please provide a width for the navigation')
  }
  const routes = {
    main: [
      // { to: '/', label: 'Home' },
      // { to: '/about', label: 'About' },
      // { to: '/contact', label: 'Contact' },
      { to: '/', label: 'HOME' },
      { label: 'ARTICLES', to: '/weight-loss-articles' },
      { label: 'STORIES', to: '/weight-loss-stories' },
      {
        label: 'WORKOUTS',
        to: '/weight-loss-workouts',
      },
      { to: '/about', label: 'ABOUT' },
      { to: '/contact', label: 'CONTACT' },
    ],
    secondary: [
      // { to: '/', label: 'HOME' },
      // { label: 'ARTICLES', to: '/weight-loss-articles' },
      // { label: 'STORIES', to: '/weight-loss-stories' },
      // {
      //   label: 'WORKOUTS',
      //   to: '/weight-loss-workouts',
      // },
      // { to: '/about', label: 'ABOUT' },
      // { to: '/contact', label: 'CONTACT' },
    ],
  }

  return (
    <div>
      <AppBar position="fixed" style={{ boxShadow: '0px 0px 2px #b6b6b6' }}>
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              background: theme.palette.background.light,
              boxShadow: 'none',
              minHeight: 50,
            }}
          >
            <nav
              style={{
                width,
                margin: 'auto',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Link to="/" title={siteConfig.siteTitle}>
                <div className={classes.logoWrapper}>
                  <img
                    src={Logo}
                    className={classes.logo}
                    alt={siteConfig.siteTitle}
                    title={siteConfig.siteTitle}
                  />
                </div>
              </Link>
              <div className={classes.navigation}>
                <div className={classes.navigationMobile}>
                  <Mobile routes={routes} />
                </div>
                <div className={classes.navigationDesktop}>
                  {routes.main.map(({ to, label }, i) => (
                    <Typography
                      key={`nav-link${i}`}
                      className={classes.navigationLink}
                      component={Link}
                      to={to}
                    >
                      {label}
                    </Typography>
                  ))}
                </div>
              </div>
              <div className={classes.followBar}>
                <FollowBar dark />
              </div>
            </nav>
          </div>
          <Secondary routes={routes} width={width} />
        </div>
      </AppBar>
    </div>
  )
}

Navigation.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export default withStyles(styles, { withTheme: true })(Navigation)



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js